// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdLabelSettingsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module ThresholdLabelSettings popup component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var FontStyle = require('share/components/controls/Izenda.FontStyle');
  var FontFormat = require('share/components/controls/Izenda.FontFormat');
  var AlignmentSetting = require('share/components/controls/Izenda.AlignmentSetting');
  var ColorPicker = require('share/components/controls/Izenda.ColorPicker');
  var Label = require('share/components/controls/Izenda.Label');
  var constant = require('logic/data/Izenda.ThresholdGridConstants');
  var UIConstants = require('logic/data/Izenda.UIConstants');
  const { flow, endsWith,toString } = require('lodash/fp');

  var ThresholdLabelSettingsPopup = React.createClass({
    getInitialState: function() {
      var props = this.props;
      var value = props.value || {};
      var fontStyle = value.fontStyle || {};
      return {
        fontSize: value.fontSize || UIConstants.defaultFontSize,
        fontFamily: value.fontFamily || UIConstants.defaultFontFamily,
        fontBold: fontStyle.fontBold || false,
        fontItalic: fontStyle.fontItalic || false,
        fontUnderline: fontStyle.fontUnderline || false,
        textColor: value.textColor || constant.DEFAULT_VALUE.COLOR,
        alignment: value.alignment || constant.DEFAULT_VALUE.ALIGNMENT
      };
    },
    /**
     * Hanld change text color picker
     * @param  {string} value
     */
    textColorChange: function(value) {
      this.setState({
        textColor: value
      });
    },

    /**
     * Hanld change text color alignment setting
     * @param  {object} e
     */
    alignmentSettingChange: function(e) {
      this.setState({
        alignment: e.value
      });
    },

    /**
     * Hanld change font format
     * @param  {object} e
     */
    onChangeFontFormat: function(e) {
      this.setState({
        fontSize: e.value.fontSize,
        fontFamily: e.value.fontFamily
      });
    },

    /**
     * Hanld change font style
     * @param  {object} e
     */
    onChangeFontStyle: function(e) {
      var value = e.value || {};
      this.setState({
        fontBold: value.fontBold,
        fontItalic: value.fontItalic,
        fontUnderline: value.fontUnderline
      });
    },

    onClosing: function(callback, type) {
      var props = this.props;
      if (type === 'cancel') {
        return props.onReject();
      }

      if (type === 'accept') {
        var fontSize = this.state.fontSize;
        var data = {
          fontSize: flow(toString, endsWith('px'))(fontSize) ? fontSize : fontSize + 'px',
          fontFamily: this.state.fontFamily,
          fontStyle: {
            fontBold: this.state.fontBold,
            fontItalic: this.state.fontItalic,
            fontUnderline: this.state.fontUnderline
          },
          textColor: this.state.textColor,
          alignment: this.state.alignment
        };

        props.onChange({ value: data });
        return props.onAccept();
      }
    },

    renderContainer: function(localization) {
      var state = this.state;
      var valueFontFormat = {
        fontSize: state.fontSize,
        fontFamily: state.fontFamily
      };

      var fontStyle = {
        fontBold: state.fontBold,
        fontItalic: state.fontItalic,
        fontUnderline: state.fontUnderline
      };

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols={3}>
              <Label className="control-label u_textNormal">{localization.getText('FONT_SETTINGS_LABEL_FONT')}</Label>
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <FontFormat value={valueFontFormat} onChange={this.onChangeFontFormat} />
              <FontStyle onChange={this.onChangeFontStyle} value={fontStyle} />
              <ColorPicker color={this.state.textColor} onChange={this.textColorChange} iconName="icon-font" />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={3}>
              <Label className="control-label u_textNormal">
                {localization.getText('FONT_SETTINGS_LABEL_ALIGNMENT')}
              </Label>
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <AlignmentSetting value={this.state.alignment} onChange={this.alignmentSettingChange} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    },

    render: function() {
      var localization = this.props.localization;
      return (
        <Popup sizeClass="modal-sm" visible onClosing={this.onClosing} autoClose={false} type="none">
          <Popup.Header title={localization.getText('REPORTDESIGNER_LABEL_THRESHOLD_LABEL_SETTINGS')} />
          <Popup.Body>{this.renderContainer(localization)}</Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type="cancel">
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect()(ThresholdLabelSettingsPopup);

  module.exports.$popupName = 'ThresholdLabelSettingsPopup';
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ThresholdLabelSettingsPopup.jsx